import * as React from 'react'

import FormHelperText from '@mui/material/FormHelperText'
import Stack from '@mui/material/Stack'

import { NAME_GROUP_ERROR_KEY, NAME_GROUP_FIELDS } from '../typings'
import { RequiredTextField } from './RequiredTextField'
import { useGroupError } from './hooks/useGroupError'
import { useGroupRequired } from './hooks/useGroupRequired'

/**
 * First name, last name and company inputs for the name OR-group. Every member shows the required
 * asterisk until one is filled, and the group rule (validateUpdateRequiredFields) decides validity;
 * a group error outlines all three and its message is shown once underneath.
 */
export function NameOrCompanyFields() {
  const { invalid, message } = useGroupError(
    NAME_GROUP_ERROR_KEY,
    NAME_GROUP_FIELDS,
  )

  const required = useGroupRequired(NAME_GROUP_FIELDS)

  return (
    <Stack spacing={2}>
      <RequiredTextField
        name="firstName"
        label="First Name"
        testId="auto-review-first-name"
        required={required}
        invalid={invalid}
      />
      <RequiredTextField
        name="lastName"
        label="Last Name"
        testId="auto-review-last-name"
        required={required}
        invalid={invalid}
      />
      <RequiredTextField
        name="company"
        label="Company Name"
        testId="auto-review-company"
        required={required}
        invalid={invalid}
      />
      {message && <FormHelperText error>{message}</FormHelperText>}
    </Stack>
  )
}

NameOrCompanyFields.displayName = 'NameOrCompanyFields'
